export default __webpack_public_path__ + "static/media/bottomconnect.20b80cc2.png";